import type { AppAction } from '../actions';

const MAX_RECENT_INDICATORS = 10;

export interface RecentlyUsedIndicatorsState {
    scanner: string[];
    screener: string[];
}

export const initialState: RecentlyUsedIndicatorsState = {
    scanner: [],
    screener: [],
};

export const recentlyUsedIndicators = (state = initialState, action: AppAction): RecentlyUsedIndicatorsState => {
    switch (action.type) {
        case 'recentlyUsedIndicators::add': {
            const { context, indicatorId } = action;
            const currentList = state[context];

            // Remove if already exists to avoid duplicates
            const filtered = currentList.filter((id) => id !== indicatorId);

            // Add to the beginning (most recent first)
            const updated = [indicatorId, ...filtered];

            // Keep only the most recent MAX_RECENT_INDICATORS items
            const trimmed = updated.slice(0, MAX_RECENT_INDICATORS);

            return {
                ...state,
                [context]: trimmed,
            };
        }

        case 'recentlyUsedIndicators::load': {
            return {
                scanner: action.scanner,
                screener: action.screener,
            };
        }

        default:
            return state;
    }
};
